export const DATA_SOURCE = 'score-insights'
export const POLL_INTERVAL = 5000
